export default __webpack_public_path__ + "static/media/youtube-mobile.a7c78387.svg";